export default __webpack_public_path__ + "static/media/partnershipIcon.ac7e7af1.png";